export default "/profile/images/sett-1.png?5cfccacccecb173db39f084edd0fecca";